(function () {
  // Mobile thumbnail overlap: -22px at 2 items, -35px at 4 items (both tested against design) —
  // +6.5px of overlap per extra item up to 4 items. Beyond 4, overlap tightens faster
  // (+12px/item) to free up room for the title/qty/savings text instead of the stack
  // growing unbounded. Capped below the mobile thumbnail width (53.8px) — must never
  // reach it or extra thumbnails start shifting the whole stack backward.
  var MOBILE_OVERLAP_BASE_PX = 22;
  var MOBILE_OVERLAP_BASE_COUNT = 2;
  var MOBILE_OVERLAP_STEP_PX = 6.5;
  var MOBILE_OVERLAP_TAPER_COUNT = 4;
  var MOBILE_OVERLAP_TAPER_STEP_PX = 12;
  var MOBILE_OVERLAP_MAX_PX = 46;
  var MOBILE_THUMB_LIMIT = 8;
  var GORGIAS_MOBILE_ACTIVE_BOTTOM_PX = 143;
  var GORGIAS_MOBILE_DEFAULT_BOTTOM_PX = 20;
  var OVERLAY_REAPPEAR_DELAY_MS = 500;

  var bar = null;
  var viewObserver = null;
  var viewFired = false;
  var refreshTimer = null;
  var resizeTimer = null;
  var productCache = {};
  var lastThumbCount = 0;
  var overlayReappearTimer = null;

  function init() {
    bar = document.getElementById('c-sticky-cart-bar');
    if (!bar) return;

    var checkoutBtn = bar.querySelector('.c-sticky-cart-bar__checkout');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        if (window.dataLayer) window.dataLayer.push({ event: 'sticky_cart_bar_click' });
        window.location.href = '/checkout';
      });
    }

    watchForViewportEntry();
    refreshCart();
    watchForCartChanges();
    watchForOverlays();

    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        if (lastThumbCount) applyThumbOverlap(lastThumbCount);
      }, 150);
    });
  }

  // The theme's own menu/drawer/modal components all toggle "overflow-hidden"
  // on <body> when open (confirmed in component-menu's enableGlobalOverlay).
  // NOTE: UpCart (cart drawer) is a third-party app embed with no confirmed
  // open/closed signal in its DOM, so it isn't covered here yet.
  function isMenuOrDrawerOpen() {
    return document.body.classList.contains('overflow-hidden');
  }

  function refreshOverlayVisibility() {
    if (!bar) return;
    clearTimeout(overlayReappearTimer);

    if (isMenuOrDrawerOpen()) {
      bar.classList.add('c-sticky-cart-bar--overlay-open');
    } else {
      overlayReappearTimer = setTimeout(function () {
        bar.classList.remove('c-sticky-cart-bar--overlay-open');
      }, OVERLAY_REAPPEAR_DELAY_MS);
    }
  }

  function watchForOverlays() {
    refreshOverlayVisibility();

    new MutationObserver(refreshOverlayVisibility).observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });
  }

  function mobileThumbOverlap(count) {
    var stepsBeforeTaper = Math.min(count, MOBILE_OVERLAP_TAPER_COUNT) - MOBILE_OVERLAP_BASE_COUNT;
    var overlap = MOBILE_OVERLAP_BASE_PX + stepsBeforeTaper * MOBILE_OVERLAP_STEP_PX;

    var stepsAfterTaper = Math.max(0, count - MOBILE_OVERLAP_TAPER_COUNT);
    overlap += stepsAfterTaper * MOBILE_OVERLAP_TAPER_STEP_PX;

    return Math.min(overlap, MOBILE_OVERLAP_MAX_PX);
  }

  function applyThumbOverlap(count) {
    var wraps = bar.querySelectorAll('.c-sticky-cart-bar__thumb-wrap');
    var isMobile = window.matchMedia('(max-width: 767px)').matches;

    wraps.forEach(function (wrap, index) {
      if (index === 0) return;
      if (!isMobile) {
        wrap.style.marginLeft = '';
        return;
      }
      wrap.style.marginLeft = '-' + Math.round(mobileThumbOverlap(count)) + 'px';
    });
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshCart, 250);
  }

  function watchForCartChanges() {
    document.addEventListener('cart:updated', scheduleRefresh);
    window.addEventListener('cart:refresh', scheduleRefresh);

    var patchedFetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0] instanceof Request ? arguments[0].url : arguments[0];
      var result = patchedFetch.apply(this, arguments);
      if (typeof url === 'string' && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        result.then(scheduleRefresh);
      }
      return result;
    };

    watchUpCart();
  }

  function watchUpCart() {
    var host = document.querySelector('#upCart');
    if (!host) {
      setTimeout(watchUpCart, 500);
      return;
    }

    var observer = new MutationObserver(scheduleRefresh);
    observer.observe(host, { attributes: true, attributeFilter: ['data-count'] });
  }

  function refreshCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart.item_count) {
          render(cart, 0);
          return;
        }
        return getMarkdownSavings(cart).then(function (savings) {
          render(cart, savings);
        });
      })
      .catch(function () {});
  }

  function getProduct(handle) {
    if (!productCache[handle]) {
      productCache[handle] = fetch('/products/' + handle + '.json')
        .then(function (r) { return r.json(); })
        .then(function (data) { return data.product; })
        .catch(function () { return null; });
    }
    return productCache[handle];
  }

  function getMarkdownSavings(cart) {
    var handles = cart.items.reduce(function (list, item) {
      if (list.indexOf(item.handle) === -1) list.push(item.handle);
      return list;
    }, []);

    return Promise.all(handles.map(getProduct)).then(function (products) {
      var variantsById = {};
      products.forEach(function (product) {
        if (!product) return;
        product.variants.forEach(function (variant) {
          variantsById[variant.id] = variant;
        });
      });

      return cart.items.reduce(function (sum, item) {
        var variant = variantsById[item.variant_id];
        if (!variant || !variant.compare_at_price) return sum;

        var compareAtCents = Math.round(parseFloat(variant.compare_at_price) * 100);
        var unitPrice = item.price / item.quantity;
        if (compareAtCents > unitPrice) {
          sum += (compareAtCents - unitPrice) * item.quantity;
        }
        return sum;
      }, 0);
    });
  }

  function render(cart, markdownSavings) {
    if (!cart.item_count) {
      bar.classList.remove('is-visible');
      setGorgiasOffset(false);
      return;
    }

    renderSummary(cart, markdownSavings);

    bar.classList.add('is-visible');
    setGorgiasOffset(true);
    refreshOverlayVisibility();
  }

  function setGorgiasOffset(active, attempt) {
    document.body.classList.toggle('c-stickyCartBarActive', active);

    if (!window.matchMedia('(max-width: 767px)').matches) return;

    var chatButton = document.querySelector('#gorgias-chat-container #chat-button');
    if (!chatButton) {
      if (active && (attempt || 0) < 10) {
        setTimeout(function () { setGorgiasOffset(active, (attempt || 0) + 1); }, 500);
      }
      return;
    }

    var targetBottom = active ? GORGIAS_MOBILE_ACTIVE_BOTTOM_PX : GORGIAS_MOBILE_DEFAULT_BOTTOM_PX;
    chatButton.style.setProperty('bottom', targetBottom + 'px', 'important');
  }

  function renderSummary(cart, markdownSavings) {
    var thumbs = bar.querySelector('.c-sticky-cart-bar__thumbs');
    var title = bar.querySelector('.c-sticky-cart-bar__title');
    var qtyEl = bar.querySelector('.c-sticky-cart-bar__qty');
    var savingsEl = bar.querySelector('.c-sticky-cart-bar__savings');
    var priceEl = bar.querySelector('.c-sticky-cart-bar__price');
    var isSingleProduct = cart.items.length === 1;

    var discountSavings = cart.items.reduce(function (sum, item) {
      return sum + Math.max(0, item.original_line_price - item.final_line_price);
    }, 0);
    var savings = discountSavings + markdownSavings;

    var isMobile = window.matchMedia('(max-width: 767px)').matches;
    var visibleThumbs = isMobile ? cart.items.slice(0, MOBILE_THUMB_LIMIT) : cart.items;
    var countHtml = !isSingleProduct
      ? '<span class="c-sticky-cart-bar__count is-visible">' + cart.items.length + '</span>'
      : '';

    var thumbsHtml = visibleThumbs.map(function (item, index) {
      var isFront = index === visibleThumbs.length - 1;
      var img = '<img class="c-sticky-cart-bar__thumb" src="' + item.image + '&width=112" alt="' + escHtml(item.product_title) + '" loading="lazy">';
      return '<div class="c-sticky-cart-bar__thumb-wrap">' + img + (isFront ? countHtml : '') + '</div>';
    }).join('');

    thumbs.innerHTML = thumbsHtml;
    lastThumbCount = visibleThumbs.length;
    applyThumbOverlap(lastThumbCount);

    if (isSingleProduct) {
      var item = cart.items[0];
      title.textContent = item.product_title;
      qtyEl.textContent = 'Qty: ' + item.quantity;
      qtyEl.classList.add('is-visible');
    } else {
      title.textContent = cart.item_count + ' ITEMS IN YOUR CART';
      qtyEl.classList.remove('is-visible');
    }

    if (!isSingleProduct && savings > 0) {
      savingsEl.innerHTML = 'Total Savings: <span>' + formatMoney(savings) + '</span>';
      savingsEl.style.display = '';
    } else {
      savingsEl.style.display = 'none';
    }

    priceEl.textContent = formatMoney(cart.total_price);
  }

  function watchForViewportEntry() {
    viewObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !viewFired && bar.classList.contains('is-visible')) {
          viewFired = true;
          if (window.dataLayer) window.dataLayer.push({ event: 'sticky_cart_bar_view' });
          viewObserver.disconnect();
        }
      });
    });
    viewObserver.observe(bar);
  }

  function formatMoney(cents) {
    if (window.theme && window.theme.money && window.theme.money.format) {
      return window.theme.money.format(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function escHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
